import { FormGroup, AbstractControl, ValidatorFn, ValidationErrors, AsyncValidatorFn } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { debounceTime, delay, map, switchMap } from 'rxjs/operators';
import { AuthService } from './auth.service';

var valid = require('card-validator');

export const hasError = (formGroup: FormGroup, formControlName: string, error: string | string[]): boolean | null => {
  const control: AbstractControl = formControlName === '' ? formGroup : formGroup?.get(formControlName);
  if (!control || !control.dirty && !control.touched) {
    return null;
  }

  if (control.invalid) {
    if (!error) {
      return control.errors != null;
    }
    if (typeof error === 'string') {
      return control.hasError(error);
    }
    return (error as string[]).some((e) => control.hasError(e));
  }
  return false;
};

export const touchFormControls = (formGroup: FormGroup): void => {
  Object.keys(formGroup.controls).forEach((field) => {
    const control = formGroup.get(field);
    control.markAsTouched({ onlySelf: true });
  });
};

export class VistekValidation {
  static postalCodeZip(countryCtrlName: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const zipExp = /^([0-9]{5}(?:-[0-9]{4})?)$/i;
      const postalCodeExp = /^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][ -]?\d[ABCEGHJ-NPRSTV-Z]\d$/i;

      let isValid = false;
      if (countryCtrlName) {
        const country = countryCtrlName && control.parent?.controls[countryCtrlName]?.value;
        isValid = (country == 1 ? postalCodeExp : zipExp).test(control.value)
      } 
      else {
        isValid = postalCodeExp.test(control.value) || zipExp.test(control.value);
      }

      return isValid ? null : { invalid: control.value };
    };
  }

  static email(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const emailExp =
        /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
      const isValid = emailExp.test(control.value);
      return isValid ? null : { invalid: control.value };
    };
  }

  static emailExists(authService: AuthService): AsyncValidatorFn {
    return (control: AbstractControl): Observable<ValidationErrors | null> => {
      if (!control.value) return null;
      return of(control.value as string).pipe(
        delay(500),
        debounceTime(3000),
        switchMap((value) =>
          authService
            .getEmailExists(value)
            .pipe(map((result) => ((result as any).AccountExists ? { emailExists: true } : null)))
        )
      );
    };
  }

  static creditCardValidator(part: string) {
    return (control: AbstractControl) : ValidationErrors | null => {

      const value = control.value;
      let optionalParameter = undefined;

      if (!value) {
          return null;
      }

      let fn = null;
      switch(part) {
        case 'number':
          fn = valid.number;
            break;
        case 'name':
          fn = valid.cardholderName;
            break;
        case 'cvv':
          fn = valid.cvv;
          optionalParameter = 3;
          break;
        case 'cid':
          fn = valid.cvv;
          optionalParameter = 4;
          break;
        case 'month':
          fn = valid.expirationMonth;
            break;
        case 'year':
          fn = valid.expirationYear;
            break;
      }

      const result = fn(value, optionalParameter);

      return result.isValid ? null : { isInvalid: true };
    }
  }
}
